module.exports = ".popup {\n  width: 400px;\n  max-width: 100%; }\n\np {\n  text-align: left; }\n\nh5 {\n  font-weight: 700;\n  margin-bottom: 10px; }\n\ninput,\n.btn {\n  width: 100%; }\n\n.btn {\n  margin-top: 5px; }\n\np {\n  font-size: 16px;\n  text-align: left;\n  margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact-carrier/contact-carrier.component.scss
// module id = 955
// module chunks = 0